module.exports = __webpack_public_path__ + "3f16e137/img/note-edit-icon.acae1669.svg";